import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const translations = {
  es: {
    // Navigation
    nav: {
      inicio: "Inicio",
      servicios: "Servicios",
      comoFunciona: "Cómo Funciona",
      opiniones: "Opiniones",
      preguntas: "Preguntas",
      contacto: "Contacto",
      menu: "Menú",
      llamar24h: "Llamar 24h",
    },
    // Hero Section
    hero: {
      badge: "Servicio 24/7 Disponible Ahora",
      title: "Grúa en Zaragoza",
      subtitle: "Servicios de asistencia en carretera 24/7",
      description: "Servicio rápido, seguro y económico. Llegamos en 30-45 minutos. Transporte de coches, motos y furgonetas.",
      ctaPrimary: "Llamar Ahora",
      ctaSecondary: "WhatsApp",
      badge1: "Llegada 30min",
      badge2: "Mejor Precio",
      badge3: "Asegurado",
    },
    // Trust Section
    trust: {
      title: "Asistencia rápida y segura en",
      location: "Zaragoza",
      paragraph1: "ofrecemos un servicio completo de transporte de vehículos que abarca desde coches y motos hasta furgonetas y maquinaria ligera.",
      paragraph2: "Con años de experiencia en el sector, nos hemos ganado una sólida reputación por brindar un servicio eficiente y seguro. Nuestro equipo altamente capacitado y nuestra flota moderna garantizan que tu vehículo será tratado con el máximo cuidado.",
      stat1: "24/7",
      stat1Text: "Disponibilidad total",
      stat2: "+1000",
      stat2Text: "Servicios realizados",
      insuranceTitle: "Seguro de Carga",
      insuranceText: "Tu vehículo 100% asegurado durante el trayecto",
    },
    // Services Section
    services: {
      title: "Nuestros Servicios de Grúa",
      subtitle: "Cubrimos todas tus necesidades de transporte y asistencia en carretera con una flota adaptada a cada situación.",
      items: [
        {
          title: "Grúa para Coches",
          description: "Transporte seguro y eficiente para todo tipo de automóviles particulares en Zaragoza y alrededores.",
        },
        {
          title: "Grúa para Motos",
          description: "Equipamiento especializado para el traslado de motocicletas sin riesgos de vuelco o daños.",
        },
        {
          title: "Grúa para Furgonetas",
          description: "Capacidad para vehículos de mayor tamaño y carga, ideal para flotas comerciales.",
        },
        {
          title: "Grúa para 4x4 y SUV",
          description: "Asistencia especializada para vehículos todoterreno y SUVs de grandes dimensiones.",
        },
        {
          title: "Asistencia en Carretera",
          description: "Ayuda inmediata: cambio de ruedas, arranque de batería y apertura de vehículos.",
        },
        {
          title: "Transporte Nacional",
          description: "Servicio de traslado de vehículos a cualquier punto de España con máxima seguridad.",
        },
      ],
    },
    // How it works
    process: {
      title: "¿Cómo solicitar una grúa en",
      titleEnd: "Zaragoza?",
      subtitle: "Solicitar una grúa es un proceso sencillo y rápido con",
      step1Title: "Contáctanos",
      step1Text: "Llámanos al",
      step1TextEnd: "o escríbenos por WhatsApp.",
      step2Title: "Información Detallada",
      step2Text: "Proporciona tu ubicación exacta y el tipo de vehículo. Te daremos un presupuesto inmediato.",
      step3Title: "Asistencia en Camino",
      step3Text: "Una de nuestras grúas llegará en aproximadamente 30-45 minutos.",
      cta: "Solicitar Grúa Ahora",
    },
    // FAQ
    faq: {
      title: "Preguntas Frecuentes",
      items: [
        {
          question: "¿Cómo pedir servicio de grúa en Zaragoza?",
          answer: "En caso de emergencia en carretera, contáctanos al +34 641 82 08 01 desde tu móvil o por WhatsApp. Estamos disponibles 24/7.",
        },
        {
          question: "¿Cuánto cuesta un servicio de grúa en Zaragoza?",
          answer: "El precio del servicio depende de la distancia, el tipo de vehículo y la ubicación. Llámanos para un presupuesto gratuito y sin compromiso.",
        },
        {
          question: "¿Cuánto tiempo tardará la grúa en llegar?",
          answer: "Nuestro objetivo es llegar entre 30 y 45 minutos, dependiendo de la ubicación y el tráfico en ese momento.",
        },
        {
          question: "¿Cuentan con grúas disponibles las 24 horas?",
          answer: "Sí, ofrecemos servicios de grúa 24/7, los 365 días del año, incluyendo festivos.",
        },
      ],
    },
    // Reviews
    reviews: {
      title: "Opiniones de nuestros clientes",
      subtitle: "Lo que dicen los clientes que han confiado en nosotros.",
      rating: "5.0/5.0",
      leaveReview: "¡Déjanos tu opinión en Google!",
      leaveReviewSub: "Tu experiencia nos ayuda a mejorar",
      items: [
        {
          name: "Valy Stanculeste",
          rating: 5,
          text: "¡Felicitaciones CLS LOGISTIC ACTIV, un equipo de profesionales muy serios y muy puntuales. Coches nuevos, todo es perfecto. ¡¡¡¡CONFÍEN EN ESTA EMPRESA!!!!",
          date: "Hace 5 meses",
        },
        {
          name: "Razvan Costoiu",
          rating: 5,
          text: "🔝🔝🔝 Una empresa de transporte muy seria y con precios honestos!! Agradecimientos especiales al Sr. Claudiu por el apoyo brindado!!",
          date: "Hace 9 meses",
        },
        {
          name: "DJ 75 VDA",
          rating: 5,
          text: "¡Servicios de calidad, gente de calidad! ¡Bravo CLS Logistic Activ!",
          date: "Hace 6 meses",
        },
        {
          name: "Marina Diana",
          rating: 5,
          text: "¡Tuve una experiencia maravillosa con CLS Logistic! Servicios rápidos, profesionales y un equipo muy dedicado. ¡Recomiendo con cariño!",
          date: "Hace 9 meses",
        },
        {
          name: "Liviu Craciun",
          rating: 5,
          text: "Profesionales. ¡Bravo!",
          date: "Hace 1 mes",
        },
        {
          name: "Lucas Grasa",
          rating: 5,
          text: "Ha sido un placer trabajar con esta empresa. Profesional, fiable y puntual. Cualidades que desafortunadamente se están perdiendo.",
          date: "Hace 5 meses",
        },
        {
          name: "Alejandro Texas",
          rating: 5,
          text: "Muy profesional, amable, buen precio, buenos servicios, todo estuvo bien. 100% recomendado.",
          date: "Hace 5 meses",
        },
        {
          name: "E H",
          rating: 5,
          text: "Puntual, fiable y accesible. Claudiu recogió mi vehículo en Girona y lo trajo de vuelta a Zaragoza al día siguiente de contactarle.",
          date: "Hace 5 meses",
        },
        {
          name: "Silvia Los Santos",
          rating: 5,
          text: "Los recomiendo con gusto, vinieron el mismo día, muy profesionales.",
          date: "Hace 4 meses",
        },
        {
          name: "DenisTrans Mudanzas",
          rating: 5,
          text: "Siempre ofrecen los mejores servicios. Una empresa seria y de confianza.",
          date: "Hace 6 meses",
        },
        {
          name: "Pedro Martinez",
          rating: 5,
          text: "El servicio de grúa fue genial, puntual, el conductor fue súper amable, muy recomendable, gracias.",
          date: "Hace 6 meses",
        },
        {
          name: "Edsel Zegarra",
          rating: 5,
          text: "Muy buenos servicios, uno de los mejores en Zaragoza.",
          date: "Hace 4 semanas",
        },
        {
          name: "Antonio Martínez",
          rating: 5,
          text: "Muy buen servicio. Recibido en el plazo acordado. Buen precio. Muy profesional.",
          date: "Hace 9 meses",
        },
        {
          name: "Serban DNS",
          rating: 5,
          text: "Transporte de primera 24/7.",
          date: "Hace 9 meses",
        },
      ],
    },
    // Footer
    footer: {
      description: "Servicio profesional de grúa y asistencia en carretera en Zaragoza. Disponibles 24 horas al día, 7 días a la semana.",
      contactTitle: "Contacto Rápido",
      linksTitle: "Enlaces",
      privacyPolicy: "Política de Privacidad",
      copyright: "Todos los derechos reservados.",
    },
    // Mobile Menu
    mobile: {
      disponible: "Disponible 24 horas / 365 días",
      llamarAhora: "Llamar Ahora",
      contactoEmail: "Email de Contacto",
    },
    // Common
    common: {
      llamar: "Llamar",
      whatsapp: "WhatsApp",
      zaragoza: "Zaragoza y alrededores",
      servicio24: "Servicio 24 Horas / 365 Días",
    },
  },
  en: {
    // Navigation
    nav: {
      inicio: "Home",
      servicios: "Services",
      comoFunciona: "How It Works",
      opiniones: "Reviews",
      preguntas: "FAQ",
      contacto: "Contact",
      menu: "Menu",
      llamar24h: "Call 24h",
    },
    // Hero Section
    hero: {
      badge: "24/7 Service Available Now",
      title: "Tow Truck in Zaragoza",
      subtitle: "24/7 Roadside Assistance Services",
      description: "Fast, safe and affordable service. We arrive in 30-45 minutes. Transport for cars, motorcycles and vans.",
      ctaPrimary: "Call Now",
      ctaSecondary: "WhatsApp",
      badge1: "30min Arrival",
      badge2: "Best Price",
      badge3: "Insured",
    },
    // Trust Section
    trust: {
      title: "Fast and safe assistance in",
      location: "Zaragoza",
      paragraph1: "we offer a complete vehicle transport service ranging from cars and motorcycles to vans and light machinery.",
      paragraph2: "With years of experience in the sector, we have earned a solid reputation for providing efficient and safe service. Our highly trained team and modern fleet guarantee that your vehicle will be treated with the utmost care.",
      stat1: "24/7",
      stat1Text: "Total availability",
      stat2: "+1000",
      stat2Text: "Services completed",
      insuranceTitle: "Cargo Insurance",
      insuranceText: "Your vehicle 100% insured during transport",
    },
    // Services Section
    services: {
      title: "Our Tow Truck Services",
      subtitle: "We cover all your transport and roadside assistance needs with a fleet adapted to every situation.",
      items: [
        {
          title: "Tow Truck for Cars",
          description: "Safe and efficient transport for all types of private automobiles in Zaragoza and surroundings.",
        },
        {
          title: "Tow Truck for Motorcycles",
          description: "Specialized equipment for transporting motorcycles without risk of tipping or damage.",
        },
        {
          title: "Tow Truck for Vans",
          description: "Capacity for larger vehicles and cargo, ideal for commercial fleets.",
        },
        {
          title: "Tow Truck for 4x4 and SUV",
          description: "Specialized assistance for off-road vehicles and large SUVs.",
        },
        {
          title: "Roadside Assistance",
          description: "Immediate help: tire changes, battery jump-starts and vehicle unlocking.",
        },
        {
          title: "National Transport",
          description: "Vehicle transfer service to any point in Spain with maximum safety.",
        },
      ],
    },
    // How it works
    process: {
      title: "How to request a tow truck in",
      titleEnd: "Zaragoza?",
      subtitle: "Requesting a tow truck is a simple and fast process with",
      step1Title: "Contact Us",
      step1Text: "Call us at",
      step1TextEnd: "or write to us on WhatsApp.",
      step2Title: "Detailed Information",
      step2Text: "Provide your exact location and vehicle type. We'll give you an immediate quote.",
      step3Title: "Help On The Way",
      step3Text: "One of our tow trucks will arrive in approximately 30-45 minutes.",
      cta: "Request Tow Truck Now",
    },
    // FAQ
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "How to request tow truck service in Zaragoza?",
          answer: "In case of roadside emergency, contact us at +34 641 82 08 01 from your mobile or via WhatsApp. We are available 24/7.",
        },
        {
          question: "How much does a tow truck service cost in Zaragoza?",
          answer: "The service price depends on the distance, type of vehicle and location. Call us for a free, no-obligation quote.",
        },
        {
          question: "How long will the tow truck take to arrive?",
          answer: "Our goal is to arrive between 30 and 45 minutes, depending on the location and traffic at that time.",
        },
        {
          question: "Do you have tow trucks available 24 hours?",
          answer: "Yes, we offer tow truck services 24/7, 365 days a year, including holidays.",
        },
      ],
    },
    // Reviews
    reviews: {
      title: "Customer Reviews",
      subtitle: "What clients who trusted us have to say.",
      rating: "5.0/5.0",
      leaveReview: "Leave us a review on Google!",
      leaveReviewSub: "Your experience helps us improve",
      items: [
        {
          name: "Valy Stanculeste",
          rating: 5,
          text: "Congratulations CLS LOGISTIC ACTIV, a team of very serious and punctual professionals. New cars, everything is perfect. TRUST THIS COMPANY!!!!",
          date: "5 months ago",
        },
        {
          name: "Razvan Costoiu",
          rating: 5,
          text: "🔝🔝🔝 A very serious transport company with honest prices!! Special thanks to Mr. Claudiu for the support provided!!",
          date: "9 months ago",
        },
        {
          name: "DJ 75 VDA",
          rating: 5,
          text: "Quality services, quality people! Bravo CLS Logistic Activ!",
          date: "6 months ago",
        },
        {
          name: "Marina Diana",
          rating: 5,
          text: "I had a wonderful experience with CLS Logistic! Fast, professional services and a very dedicated team. Highly recommend!",
          date: "9 months ago",
        },
        {
          name: "Liviu Craciun",
          rating: 5,
          text: "Professionals. Bravo!",
          date: "1 month ago",
        },
        {
          name: "Lucas Grasa",
          rating: 5,
          text: "It was a pleasure working with this company. Professional, reliable and punctual. Qualities that are unfortunately being lost.",
          date: "5 months ago",
        },
        {
          name: "Alejandro Texas",
          rating: 5,
          text: "Very professional, friendly, good price, good services, everything was fine. 100% recommended.",
          date: "5 months ago",
        },
        {
          name: "E H",
          rating: 5,
          text: "Punctual, reliable and accessible. Claudiu picked up my vehicle from Girona and brought it back to Zaragoza the day after I contacted him.",
          date: "5 months ago",
        },
        {
          name: "Silvia Los Santos",
          rating: 5,
          text: "I gladly recommend them, they came the same day, very professional.",
          date: "4 months ago",
        },
        {
          name: "DenisTrans Mudanzas",
          rating: 5,
          text: "They always offer the best services. A serious and trustworthy company.",
          date: "6 months ago",
        },
        {
          name: "Pedro Martinez",
          rating: 5,
          text: "The tow service was great, punctual, the driver was super friendly, highly recommended, thank you.",
          date: "6 months ago",
        },
        {
          name: "Edsel Zegarra",
          rating: 5,
          text: "Very good services, one of the best in Zaragoza.",
          date: "4 weeks ago",
        },
        {
          name: "Antonio Martínez",
          rating: 5,
          text: "Very good service. Received within the agreed time. Good price. Very professional.",
          date: "9 months ago",
        },
        {
          name: "Serban DNS",
          rating: 5,
          text: "Top-notch transport 24/7.",
          date: "9 months ago",
        },
      ],
    },
    // Footer
    footer: {
      description: "Professional tow truck and roadside assistance service in Zaragoza. Available 24 hours a day, 7 days a week.",
      contactTitle: "Quick Contact",
      linksTitle: "Links",
      privacyPolicy: "Privacy Policy",
      copyright: "All rights reserved.",
    },
    // Mobile Menu
    mobile: {
      disponible: "Available 24 hours / 365 days",
      llamarAhora: "Call Now",
      contactoEmail: "Contact Email",
    },
    // Common
    common: {
      llamar: "Call",
      whatsapp: "WhatsApp",
      zaragoza: "Zaragoza and surroundings",
      servicio24: "24 Hours Service / 365 Days",
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved language preference
    if (typeof window !== 'undefined') {
      return localStorage.getItem('language') || 'es';
    }
    return 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    // Update HTML lang attribute
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
